import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(2)}px`,
    marginBottom: theme.spacing(2),
  },
});

const TitleSection = ({
  className,
  classes,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <MetaControlField attr={'outcomeName'} />
      <MetaControlField attr={'title'} />
      <MetaControlField
        attr={'subtitle'}
        hideEmptyFields
      />
    </div>
  );
};

TitleSection.defaultProps = {
  className: '',
};

TitleSection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TitleSection);
